import { useCallback, useEffect } from 'react';
import { Breakpoint, useIsBreakpointUp } from '@styles/breakpoints';

// Gestion de la synchronisation du scroll horizontal
const useHorizontalScrollSync = (
  containerElementHTML: HTMLElement | null | undefined,
  stickyHeaderElementHTML: HTMLElement | null | undefined,
  overflow: boolean | undefined
) => {
  const isDesktop = useIsBreakpointUp(Breakpoint.l);

  // GESTION SYNC DU SCROLL HORIZONTAL DU COMPOSANT STICKY QUAND LE CONTENEUR EST SCROLL
  const updateHorizontalStickyElementScroll = useCallback(() => {
    if (overflow && containerElementHTML && stickyHeaderElementHTML) {
      stickyHeaderElementHTML.scroll({ behavior: 'instant', left: containerElementHTML.scrollLeft });
    }
  }, [containerElementHTML, stickyHeaderElementHTML, overflow]);

  // SYNC SCROLL HORIZONTAL DU CONTENEUR QUAND HEADER STICKY EST SCROLL
  const updateHorizontalContainerScroll = useCallback(() => {
    if (containerElementHTML && stickyHeaderElementHTML && overflow && !isDesktop) {
      containerElementHTML?.scroll({ behavior: 'instant', left: stickyHeaderElementHTML.scrollLeft });
    }
  }, [containerElementHTML, stickyHeaderElementHTML, !isDesktop, overflow]);

  // Lorsque n'importe que état du composant change, synchronisation de la position de scroll du composant sticky avec le conteneur
  useEffect(() => {
    if (stickyHeaderElementHTML && containerElementHTML) {
      stickyHeaderElementHTML.scroll({ behavior: 'instant', left: containerElementHTML.scrollLeft });
    }
  });

  // Écoute du scroll sur le composant sticky
  useEffect(() => {
    if (overflow && stickyHeaderElementHTML && !isDesktop) {
      stickyHeaderElementHTML.addEventListener('scroll', updateHorizontalContainerScroll);
    }

    if (overflow && containerElementHTML) {
      containerElementHTML.addEventListener('scroll', updateHorizontalStickyElementScroll);
    }

    // Fonction de nettoyage pour enlever les événements
    return () => {
      if (overflow && stickyHeaderElementHTML && !isDesktop) {
        stickyHeaderElementHTML.removeEventListener('scroll', updateHorizontalContainerScroll);
      }

      if (overflow && containerElementHTML) {
        containerElementHTML.removeEventListener('scroll', updateHorizontalStickyElementScroll);
      }
    };
  }, [
    stickyHeaderElementHTML,
    containerElementHTML,
    updateHorizontalContainerScroll,
    updateHorizontalStickyElementScroll,
    overflow,
    isDesktop,
  ]);
};

export default useHorizontalScrollSync;
